import React from 'react';
export function Gift() {
  return <section id="darilo" className="py-24 px-6 scroll-mt-24" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <div className="text-center mb-12" data-id="element-42">
          <h2 className="text-3xl md:text-4xl mb-6" data-id="element-43">Darilo</h2>
          <div className="w-12 h-px bg-gold/50 mx-auto" data-id="element-44"></div>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-10 bg-white/40 rounded-sm border border-olive/5 shadow-sm p-8 md:p-10" data-id="element-45">
          <div className="w-48 h-48 md:w-56 md:h-56 flex-shrink-0 overflow-hidden rounded-sm border-4 border-white shadow-sm" data-id="element-46">
            <img src="https://images.unsplash.com/photo-1513885535751-8b9238bd345a?auto=format&fit=crop&w=600&q=80" alt="Darilna škatla v rjavem ovojnem papirju" className="w-full h-full object-cover" data-id="element-47" />
          </div>
          <p className="text-lg md:text-xl font-light leading-relaxed text-soft-brown/90 text-center md:text-left" data-id="element-48">
            Najlepše darilo je, da pridete. Na prostoru pa bomo imeli tudi
            darilno škatlo – zbrano gre v skupni dar.
          </p>
        </div>
      </div>
    </section>;
}